const sanitizeEmojiValue = value => value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const extractIconRenderer = (data, renderers) => {
  const prefix = data['atlassian:titlePrefix'];
  if ((prefix === null || prefix === void 0 ? void 0 : prefix['@type']) === 'atlassian:Emoji') {
    const emojiId = sanitizeEmojiValue(prefix['text']);
    const emojiRenderer = renderers === null || renderers === void 0 ? void 0 : renderers.emoji;
    if (emojiId && emojiRenderer) {
      return () => emojiRenderer(emojiId);
    }
  }
};
export default extractIconRenderer;